import Service from '../Service';

export default class Pagination extends Service {
  constructor(cacheQuery, cache, pageSize) {
    super();
    this.initialize();
    this.__cacheQuery = cacheQuery;
    this.__cache = cache;
    cache.onStateUpdate(this.__updatePage);
    this.pageSize = pageSize || 12;
  }
  initialize() {
    if (this.__cache) {
      const lastPage = Math.max(this.page, 1);
      for (let i = 1; i <= lastPage; i += 1) {
        const cacheQuery = this.__cacheQuery(i);
        this.__cache.__deleteQueryFromCache(cacheQuery);
      }
    }
    this.__currentPageTotal = 0;
    this.page = 0;
    this.__localPage = [];
  }
  get currentPage() {
    if (!this.initialized) this.page = 1;
    return this.__getCurrentPage();
  }
  get initialized() {
    return this.page > 0;
  }
  addLocalPage(object) {
    if (this.currentPage.find((o) => o._id === object._id)) return;
    this.__localPage = this.__localPage.filter(({ _id }) => _id);
    this.__localPage.push(object);
    this.emitStateUpdate();
  }
  getMore() {
    if (this.initialized && !this.showMore) return;
    this.page += 1;
    this.__getCurrentPage();
  }
  get showMore() {
    return this.page * this.pageSize === this.__currentPageTotal;
  }
  __updatePage = () => {
    if (!this.initialized) return;
    this.__getCurrentPage();
    this.emitStateUpdate();
  }
  __getCurrentPage() {
    let _currentPage = [];
    this.allFound = true;
    for (let i = 1; i <= this.page; i += 1) {
      if (this.allFound) {
        const _trees = this.__cache.query(this.__cacheQuery(i));
        if (!_trees) this.allFound = false;
        else _currentPage = [..._currentPage, ..._trees];
      }
    }
    this.__currentPageTotal = _currentPage.length;
    const queriedIds = new Set(_currentPage.map(({ _id }) => String(_id)));
    const newLocalPage = [];
    this.__localPage.forEach((o) => {
      if (!o?._id) {
        newLocalPage.push(o);
        return;
      }
      const latest = this.__cache.objects[o._id] || this.__cache.objects[String(o._id)] || o;
      if (queriedIds.has(String(latest._id))) {
        return;
      }
      if (!_currentPage.find(({ _id }) => _id === latest._id)) _currentPage.unshift(latest);
      newLocalPage.push(latest);
    });
    this.__localPage = newLocalPage;
    return _currentPage;
  }
}
